var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3574",
    "data-name": "Group 3574",
    transform: "translate(-1258 -242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12240",
    "data-name": "Path 12240",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    transform: "translate(1258 242)",
    fill: "#c2fae5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-share-link-875784",
    transform: "translate(1267 250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3356",
    "data-name": "Group 3356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3355",
    "data-name": "Group 3355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32239",
    "data-name": "Path 32239",
    d: "M430.656,220.459v0h-3.737a1.463,1.463,0,0,0-1.457,1.459v7.322a1.461,1.461,0,0,0,1.459,1.459h7.322a1.462,1.462,0,0,0,1.459-1.463V226.3h0a.731.731,0,0,1,1.463,0h0v2.943a2.925,2.925,0,0,1-2.922,2.925h-7.322A2.923,2.923,0,0,1,424,229.244v-7.322A2.926,2.926,0,0,1,426.919,219h3.737v0a.731.731,0,0,1,0,1.456Zm1.833,5.2.905.905L431.1,228.86c-.813.813-2.22.547-3.194-.427s-1.239-2.381-.429-3.191l2.3-2.3.905.905-2.3,2.3c-.206.206-.085.838.444,1.366s1.159.651,1.369.441Zm1.827-.016-.905-.905,2.293-2.293c.21-.21.091-.836-.441-1.369s-1.161-.649-1.366-.444l-2.3,2.3-.905-.905,2.3-2.3c.81-.81,2.221-.54,3.191.429s1.24,2.381.427,3.194Zm-1.8-2.727a.64.64,0,1,1,.905.905l-1.848,1.848a.64.64,0,1,1-.905-.905Z",
    transform: "translate(-424 -219)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy-link.d206e9f2b7d45393f0e68f8e4cee670e.svg";
export { ForwardRef as ReactComponent };